import type { TaskFlowRequest } from '@/lib/task-flow/taskFlowStore'

export async function createAdvancedContentProject(params: {
  request: TaskFlowRequest
  plan: any
  direction: any
  discovery: any
}) {
  const {
    request,
    plan,
    direction,
    discovery,
  } = params

  const goal = String(
    direction?.contentGoal ||
      plan?.goal ||
      ''
  ).toLowerCase()

  const publishTarget = String(
    direction?.publishTarget || ''
  ).toLowerCase()

  const projectType =
    goal === 'ugc'
      ? 'ugc_avatar_video'
      : goal === 'product'
        ? 'product_ad'
        : publishTarget === 'youtube'
          ? 'youtube_video'
          : 'content_pipeline'

  const res = await fetch(
    '/api/creator-studio/projects',
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        sellerId:
          request.payload?.sellerId,

        type: projectType,

        mode: 'advanced',

        title:
          plan?.title ||
          'Nuevo proyecto creativo',

        objective:
          plan?.objective ||
          discovery?.objective ||
          '',

        currentStep: 'ideas',

        brief: {
          ...(plan || {}),

          title:
            plan?.title ||
            'Nuevo proyecto creativo',

          objective:
            plan?.objective ||
            discovery?.objective ||
            '',

          hook: plan?.hook || '',
          cta: plan?.cta || '',
          productName:
            plan?.productName || '',

          audience:
            plan?.audience ||
            discovery?.audience ||
            '',

          language:
            plan?.language || 'es',

          aspectRatio:
            plan?.aspectRatio ||
            (direction?.publishTarget ===
            'youtube'
              ? '16:9'
              : '9:16'),

          durationMode:
            direction?.durationMode ||
            plan?.durationMode ||
            'auto',

          durationTargetSec:
            Number(
              direction?.durationTargetSec ||
                plan?.durationTargetSec ||
                60
            ),

          productionMode:
            direction?.productionMode ||
            plan?.productionMode ||
            'express',

          visualOutputMode:
            direction?.visualOutputMode ||
            plan?.visualOutputMode ||
            'mixed',

          goal:
            plan?.goal ||
            direction?.contentGoal ||
            'viral',

          style: plan?.style || '',
          musicMood:
            plan?.musicMood || '',
          voiceStyle:
            plan?.voiceStyle || '',
        },

        creativeDirection: direction,

        projectJson: null,

        skillAgentId:
          request.payload?.skillAgentId ||
          request.payload?.skill_agent_id ||
          null,

        skillAgentSlug:
          request.payload?.skillAgentSlug ||
          request.payload?.skill_agent_slug ||
          null,

        skillAgentName:
          request.payload?.skillName ||
          request.payload?.skillAgentName ||
          request.payload?.skill_agent_name ||
          null,
      }),
    }
  )

  const json =
    await res.json().catch(() => null)

  if (
    !res.ok ||
    !json?.ok ||
    !json?.projectId
  ) {
    throw new Error(
      json?.error ||
        'No se pudo crear el proyecto en Creator Studio.'
    )
  }

  return {
    projectId: Number(json.projectId),
    project: json.project || null,
  }
}